export function resolveProductImageLink(imageLink) {
  if (imageLink == null || imageLink === '') {
    return imageLink;
  }
  return String(imageLink).replace('-option-subs', '');
}
